import React from 'react'
import PropTypes from 'prop-types'

const Pagination = props => {
    const { inOffset, data, showNext, total, className } = props
    return (
        <div className={className}>
            <div className="hsg-dashboard-pagination-page">
                <span className="hsg-dashboard-pagination-page-on">
                    {inOffset + 1}{'-' + (inOffset + data.length)}
                </span>
                {' of ' + total}
            </div>
            <button 
                onClick={() => showNext('prev')} 
                className={inOffset === 0 ? "hsg-btn-disabled pagination-btn" : "pagination-btn hsg-btn-nxt"} 
                style={{
                    background: inOffset === 0 ? 'rgba(143,195,249)' : 'rgba(30, 135, 240, 1)',
                    color: inOffset === 0 ? 'rgba(30, 135, 240, 1)' : ''
                }}
                disabled={inOffset === 0}
            >
                <span aria-hidden="true" data-icon="&#xe906;" className="icon-previous"></span>
            </button>&nbsp;
            <button 
                onClick={() => showNext('next')} 
                className={(total - inOffset) <= data.length ? "hsg-btn-disabled pagination-btn" : "pagination-btn hsg-btn-nxt"} 
                style={{
                    background: (total - inOffset) <= data.length ? 'rgba(143,195,249)' : 'rgba(30, 135, 240, 1)',
                    color: (total - inOffset) <= data.length ? 'rgba(30, 135, 240, 1)' : ''
                }}
                disabled={(total - inOffset) <= data.length}
            >
                <span aria-hidden="true" data-icon="&#xe908;" className="icon-next"></span>
            </button>
        </div>
    )
}

export default Pagination

Pagination.propTypes = {
    data: PropTypes.array.isRequired,
    total: PropTypes.number.isRequired,
    className: PropTypes.string.isRequired,
    showNext: PropTypes.func.isRequired
}
